import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'

type DeleteItemFromMultiCartResponse = paths['/api/carts/multi-carts/{multiCartId}/item/{itemId}']['delete']['responses']['204']

async function deleteItemFromMultiCart(multiCartId: string, itemId: string): Promise<{ success: boolean }> {
  await request.delete<DeleteItemFromMultiCartResponse>(`/api/carts/multi-carts/${multiCartId}/item/${itemId}`, { credentials: 'include' })
  return { success: true }
}

export async function deleteItemsFromMultiCart(multiCartId: string, multiCartItemIds: Array<string>): Promise<{ success: boolean }> {
  await Promise.all(multiCartItemIds.map(itemId => deleteItemFromMultiCart(multiCartId, itemId)))
  return { success: true }
}
